import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Navigation } from './components/shared/Navigation';
import { Footer } from './components/shared/Footer';
import { LandingPage } from './pages/LandingPage';
import { DepartmentPage } from './pages/DepartmentPage';
import { FacultyProfilePage } from './pages/FacultyProfilePage';
import { CVGeneratorPage } from './pages/CVGeneratorPage';
import { ClubPage } from './pages/ClubPage';
import { CalendarPage } from './pages/CalendarPage';
export function App() {
  return <Router data-id="element-0">
      <div className="min-h-screen flex flex-col font-sans" data-id="element-1">
        <Navigation data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<LandingPage data-id="element-6" />} data-id="element-5" />
            <Route path="/department/cse" element={<DepartmentPage data-id="element-8" />} data-id="element-7" />
            <Route path="/faculty/profile" element={<FacultyProfilePage data-id="element-10" />} data-id="element-9" />
            <Route path="/faculty/cv-generator" element={<CVGeneratorPage data-id="element-12" />} data-id="element-11" />
            <Route path="/clubs/programming" element={<ClubPage data-id="element-14" />} data-id="element-13" />
            <Route path="/academic-calendar" element={<CalendarPage data-id="element-16" />} data-id="element-15" />
          </Routes>
        </main>
        <Footer data-id="element-17" />
        <Toaster position="bottom-right" theme="light" toastOptions={{
        style: {
          background: 'white',
          border: '1px solid #e2e8f0',
          color: '#1e293b',
          boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)'
        }
      }} data-id="element-18" />
      </div>
    </Router>;
}